import { Col, Modal, Row } from 'react-bootstrap';
import React, { Component } from 'react';
import { checkForUserRole, handleErrorMessage } from '../../utils';

import ButtonSave from '../Reusable/ButtonSave';
import ComboBoxAutocomplete from '../../components/Reusable/ComboBoxAutocomplete';
import InputField from '../Reusable/InputField';
import KJSMunicipalityTable from '../KJSMunicipality/KJSMunicipalityTable';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import { isNull } from 'lodash';
import { userRoles } from '../../constants/globals';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForUpdateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      umcn: '',
      firstName: '',
      lastName: '',
      username: '',
      roles: this.getSelectedRoleNames(),
      errors: {},
      place: null,
      municipality: null,
      institutionType: null,
      kjs: null,
      kjsMunicipalityList: [],
      pib: '',
      uniqueKjsNumber: '',
    };

    this.typingTimeout = null;
  }

  componentDidMount() {
    const { user } = this.props;
    this.setState({
      ...user,
      roles: this.getSelectedRoleNames(),
      kjsMunicipalityList: user.kjsList,
    });
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onKjfFilterChange = (e) => {
    clearTimeout(this.typingTimeout);

    this.typingTimeout = setTimeout(this.handleFilterKJSList, 1800);

    this.setState({ [e.target.name]: e.target.value });
  };

  handleFilterKJSList = async (newInstitutionType, resetSignal) => {
    let filterCriteriaData = this.setFilterCriteria(
      newInstitutionType,
      resetSignal
    );
    filterCriteriaData.length > 0
      ? await this.props.findAllKjsFilterPageable(
          0,
          100000,
          {
            tableName: 'kjs',
            filterCriteria: filterCriteriaData,
          },
          () => this.handleClose
        )
      : this.props.findAllKjs();
  };

  setFilterCriteria = (newInstitutionType, resetSignal) => {
    const { pib, uniqueKjsNumber, institutionType } = this.state || {};
    let filterCriteriaData = [];
    if (pib)
      filterCriteriaData.push({
        columnName: 'pib',
        columnValue: pib,
      });
    if (uniqueKjsNumber)
      filterCriteriaData.push({
        columnName: 'uniqueNumber',
        columnValue: uniqueKjsNumber,
      });
    if (!resetSignal && (institutionType || newInstitutionType))
      filterCriteriaData.push({
        columnName: 'institutionType.uniqueId',
        columnValue: newInstitutionType
          ? newInstitutionType.uniqueId
          : institutionType.uniqueId,
      });
    return filterCriteriaData;
  };

  handleAddRoles = (checkedRoles) => {
    this.setState({ roles: checkedRoles });
  };

  getRoleNames = (rolesHashMapList) => {
    const { Role } = this.props.enums || {};
    let roleNames = [];
    rolesHashMapList.forEach((role) =>
      roleNames.push(Role[role.roleName]?.text)
    );
    return roleNames;
  };

  getSelectedRoleNames = () => {
    const { Role } = this.props.enums || {};
    let selectedRoleNames = [];
    let selectedRoles = this.props.user.roles.slice();
    for (let i = 0; i < selectedRoles.length; i++) {
      selectedRoleNames.push(Role[selectedRoles[i].roleName]?.text);
    }
    return selectedRoleNames;
  };

  handleRoles = (selectedRoleNames) => {
    const { Role } = this.props.enums || {};
    const roleObjects = this.props.rolesHashMapList;

    return selectedRoleNames.map((srn) => {
      const roleObject = roleObjects.find(
        (ro) => srn === Role[ro.roleName]?.text
      );
      return { ...roleObject };
    });
  };

  handleKJSMunicipalityAdd = () => {
    const { kjs, municipality } = this.state;
    const kjsMunicipality = {
      kjs: kjs,
      municipality: municipality,
      user: this.props.user,
    };
    this.setState({
      kjsMunicipalityList: this.state.kjsMunicipalityList.concat(
        kjsMunicipality
      ),
      place: null,
      municipality: null,
      institutionType: null,
      kjs: null,
    });
  };

  handleDeleteKJSMunicipality = (kjsMunicipalityForDelete) => {
    const { t, gt } = this.props || {};
    const action = () => {
      this.setState({
        kjsMunicipalityList: this.state.kjsMunicipalityList.filter(
          (kjsMunicipality) => kjsMunicipality !== kjsMunicipalityForDelete
        ),
      });
    };
    confirmDialog(t.ConfirmDialog.deleteKjsMunicipality, action, '', gt);
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    if (!this.state.umcn) {
      errors['umcn'] = this.props.t.Errors.umcn;
      hasError = true;
    }

    if (!this.state.firstName) {
      errors['firstName'] = this.props.t.Errors.firstName;
      hasError = true;
    }

    if (!this.state.lastName) {
      errors['lastName'] = this.props.t.Errors.lastName;
      hasError = true;
    }

    if (!this.state.username) {
      errors['username'] = this.props.t.Errors.username;
      hasError = true;
    }

    if (
      (!this.state.kjs && this.state.kjsMunicipalityList.length === 0) ||
      this.state.kjsMunicipalityList.length === 0
    ) {
      errors['kjs'] = this.props.t.Errors.kjs;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const updatedUser = {
      id: this.props.user.id,
      umcn: this.state.umcn,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      username: this.state.username,
      active: this.state.active,
      roles: this.handleRoles(this.state.roles),
      systemId: 2,
      kjsList: this.state.kjsMunicipalityList,
    };
    const { NotificationMessages } = this.props.t;
    this.props.handleEdit(updatedUser, NotificationMessages);
  };

  changeComboAutocomplete = (name, newValue) => {
    switch (name) {
      case 'autonomousProvince':
        if (!newValue) {
          this.setState({ coatOfArmsAppearance: null });
          this.props.findAllPlaceWithoutAutonomousProvince();
        } else {
          this.props.findAllPlaceByAutonomousProvince(newValue.id);
          this.setState({
            coatOfArmsAppearance: this.state.coatOfArmsAppearances[2],
          });
        }
        this.setState({
          autonomousProvince: newValue,
          place: null,
          municipality: null,
          institutionType: null,
          kjs: null,
        });
        break;
      case 'place':
        if (!newValue) {
          this.props.clearMunicipalityList();
        } else {
          this.props.findAllMunicipalityByPlace(newValue.id);
        }
        this.setState({
          place: newValue,
          municipality: null,
          institutionType: null,
          kjs: null,
        });
        break;
      case 'municipality':
        if (!newValue) {
          this.props.clearKjsList();
        } else {
          this.props.kjsList.length === 0 && this.props.findAllKjs();
        }
        this.setState({
          municipality: newValue,
          institutionType: null,
          kjs: null,
        });
        break;
      case 'institutionType':
        if (!newValue) {
          this.props.clearKjsList();
          this.handleFilterKJSList(newValue, true);
        } else {
          this.handleFilterKJSList(newValue);
        }
        this.setState({
          institutionType: newValue,
          kjs: null,
        });
        break;
      case 'kjs':
        this.setState({
          kjs: newValue,
        });
        break;
      case 'roles':
        this.setState({ roles: newValue, kjsMunicipalityList: [] });
        break;
      default:
        this.setState({ [name]: newValue });
    }
  };

  render() {
    const { error, rolesHashMapList, t, institutionTypeList } =
        this.props || {},
      { Placeholders, Tooltips } = t || {};
    const { kjs, kjsMunicipalityList } = this.state;
    const roleNames = this.getRoleNames(rolesHashMapList);
    const sortedInstitutionTypeList = institutionTypeList.sort(function (a, b) {
      return a.uniqueId - b.uniqueId;
    });
    const roleList = this.handleRoles(this.state.roles);
    const isAddingDisabled =
      isNull(kjs) ||
      this.state.roles[0] === '' ||
      (!checkForUserRole(roleList, userRoles.AUTHORIZED_PERSON.value + '') &&
        this.state.kjsMunicipalityList.length === 1);

    const disabledIconStyle = isAddingDisabled && 'gray-color';
    const kjsAddDisabledStyle =
      this.state.roles.length > 0 ? '' : 'preview-style';

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{t.Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <Row className="mb-4">
                <Col md={4}>
                  <InputField
                    name="umcn"
                    placeholder={Placeholders.umcn}
                    onChange={this.onChange}
                    value={this.state.umcn}
                    error={handleErrorMessage(
                      error,
                      'umcn',
                      this.state.errors.umcn
                    )}
                    disabled
                  />
                </Col>
                <Col md={4}>
                  <InputField
                    name="firstName"
                    placeholder={Placeholders.firstName}
                    onChange={this.onChange}
                    value={this.state.firstName}
                    error={handleErrorMessage(
                      error,
                      'firstName',
                      this.state.errors.firstName
                    )}
                  />
                </Col>
                <Col md={4}>
                  <InputField
                    name="lastName"
                    placeholder={Placeholders.lastName}
                    onChange={this.onChange}
                    value={this.state.lastName}
                    error={handleErrorMessage(
                      error,
                      'lastName',
                      this.state.errors.lastName
                    )}
                  />
                </Col>
              </Row>
              <Row md={12} className="justify-content-around">
                <Col md={5}>
                  <InputField
                    name="username"
                    placeholder={Placeholders.username}
                    onChange={this.onChange}
                    value={this.state.username}
                    error={handleErrorMessage(
                      error,
                      'username',
                      this.state.errors.username
                    )}
                  />
                </Col>
                <Col md={5}>
                  <ComboBoxAutocomplete
                    data={roleNames}
                    text={(role) => role}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('roles', [newValue])
                    }
                    placeholder={Placeholders.role}
                    wholeObject
                    updateValue={this.state.roles[0]}
                  />
                </Col>
              </Row>
              <hr className="mt-5" />
              <Row disabled className={`mb-4 mt-5 ${kjsAddDisabledStyle}`}>
                <Col md={3}>
                  <ComboBoxAutocomplete
                    data={this.props.placeList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('place', newValue)
                    }
                    text={(a) => a.name}
                    placeholder={Placeholders.place}
                    wholeObject
                    updateValue={this.state.place}
                    error={this.props.errors?.place}
                  />
                </Col>
                <Col md={4}>
                  <ComboBoxAutocomplete
                    data={this.props.municipalityList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('municipality', newValue)
                    }
                    placeholder={Placeholders.municipalities}
                    text={(a) => a.name}
                    wholeObject
                    updateValue={this.state.municipality}
                    error={this.props.errors?.municipality}
                    disabled={!this.state.place}
                  />
                </Col>
                <Col md={5}>
                  <ComboBoxAutocomplete
                    data={sortedInstitutionTypeList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('institutionType', newValue)
                    }
                    placeholder={Placeholders.institutionType}
                    text={(a) => a.name}
                    wholeObject={true}
                    updateValue={this.state.institutionType}
                    error={this.props.errors?.institutionType}
                    disabled={!this.state.municipality}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col md={6}>
                  <InputField
                    name="pib"
                    placeholder={Placeholders.pib}
                    onChange={this.onKjfFilterChange}
                    value={this.state.pib}
                    autoComplete="off"
                    disabled={!this.state.municipality}
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    name="uniqueKjsNumber"
                    placeholder={Placeholders.uniqueKjsNumber}
                    onChange={this.onKjfFilterChange}
                    value={this.state.uniqueKjsNumber}
                    autoComplete="off"
                    disabled={!this.state.municipality}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col md={11}>
                  <ComboBoxAutocomplete
                    data={this.props.kjsList}
                    changeValue={(newValue) =>
                      this.changeComboAutocomplete('kjs', newValue)
                    }
                    placeholder={Placeholders.kjs}
                    text={(a) => a.name}
                    wholeObject={true}
                    updateValue={this.state.kjs}
                    error={this.state.errors?.kjs}
                    disabled={!this.state.municipality}
                  />
                </Col>
                <Col md={1} className="text-center">
                  <Tooltip
                    title={Tooltips.addItem}
                    placement="top"
                    arrow={true}
                  >
                    <Link
                      onClick={() =>
                        !isAddingDisabled && this.handleKJSMunicipalityAdd()
                      }
                      to="#"
                    >
                      <i
                        className={`fas fa-plus fa-2x p-1 ${disabledIconStyle}`}
                      />
                    </Link>
                  </Tooltip>
                </Col>
              </Row>
              <KJSMunicipalityTable
                kjsMunicipalityList={kjsMunicipalityList}
                handleDeleteItem={this.handleDeleteKJSMunicipality}
              />
              <div className="row mt-5">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(ModalForUpdateUser, 'ModalForUpdateUser');
